// Core
import PropTypes from "prop-types";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Components
import { Button, Crumbs } from "components/AtomsV2";
import { Icon } from "components/ShellV2";

// Redux
import { useSelector } from "react-redux";
import { selectCurrentCommunity } from "state/communities/communitiesSlice";

// Table
import LossesTable from "./LossesDataTable";
import TariffsTable from "./TariffsDataTable";

function SingleERSE({ propKey }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: communityId } = useParams();
  const community = useSelector(selectCurrentCommunity);
  const { t } = useTranslation(["erse"]);
  const { t: tCommunity } = useTranslation(["community"]);

  const tables = {
    tariffs: {
      component: <TariffsTable />,
      title: t("list.sections.tariffs.title"),
    },
    losses: {
      component: <LossesTable />,
      title: t("list.sections.losses.title"),
    },
  };

  const table = tables[propKey];
  const isAdminRoute = location.pathname.startsWith("/communities/admin");
  const backPath = isAdminRoute
    ? "/communities/admin"
    : `/communities/${communityId}/configuration`;
  const backLabel = isAdminRoute
    ? t("single.back_to_admin", { defaultValue: "Voltar à administração" })
    : t("single.back_to_configuration", { defaultValue: "Return to configuration" });

  const crumbs = isAdminRoute
    ? [
        { label: t("single.admin", { defaultValue: "Administração" }), to: backPath },
        { label: table.title },
      ]
    : [
        { label: community?.name || "—" },
        { label: tCommunity("config.title"), to: backPath },
        { label: table.title },
      ];

  return (
    <div>
      <Crumbs items={crumbs} />
      <div className="rec-page-head">
        <Button variant="ghost" size="sm" onClick={() => navigate(backPath)}>
          <Icon name="arrow_back" />
          {backLabel}
        </Button>
      </div>

      <div className="rec-card overflow-hidden">{table.component}</div>
    </div>
  );
}

SingleERSE.propTypes = {
  propKey: PropTypes.oneOf(["tariffs", "losses"]).isRequired,
};

export default SingleERSE;
